export default {
  subscribers: state => state.newsletter.subscribers,
  subscriberInfos: state => state.newsletter.subscriberInfos,
  totalPages: state => state.totalPages
}
